import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import Profile from "../pages/Profile";
import ProtectedRouteV2 from "./ProtectedRouteV2";

const profileRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/profile"
      element={
        <>
          <PageTitle title="Perfil | Codenova POS System" />
          <Profile />
        </>
      }
    />
  </Route>
);

export default profileRoutes;
